import { useMemo } from 'react'

import { AchPaymentMode } from '@b-stock/account-api-client'
import type { OnlinePaymentModes } from '@b-stock/account-api-client'

import useAccount from '@/buyer-portal/helpers/useAccount'

/**
 * Maps the account's ACH payment mode to the buyer-facing settlement mode.
 * Anything the client does not recognize — an absent field, an absent account,
 * a future enum member — is 'unknown', which means "render today's UI".
 */
export const selectAchSettlementMode = (
  onlinePaymentModes?: OnlinePaymentModes
) => {
  switch (onlinePaymentModes?.ach) {
    case AchPaymentMode.Settled:
      return 'settled'
    case AchPaymentMode.FundsAvailable:
      return 'funds-available'
    default:
      return 'unknown'
  }
}

export type AchSettlementMode = ReturnType<typeof selectAchSettlementMode>

export const useAchSettlementMode = () => {
  const account = useAccount()
  return useMemo(
    () => selectAchSettlementMode(account.data?.onlinePaymentModes),
    [account.data?.onlinePaymentModes]
  )
}
